<template>
  <div>
    <div class="tab-title">粉丝列表</div>
    <div class="list-wrap">
      <ul class="list-container" v-loading="loadList">
        <li
          class="list-item flex"
          v-for="(item, index) in fansList"
          :key="index"
        >
          <div class="user-avatar-wrap" @click="userCenterLink(item)">
            <UserAvatar
              :src="item.thumbHeadImg || item.headImgUrl"
              shape="fans-avtar"
            />
          </div>
          <div class="user-info-container">
            <p @click="userCenterLink(item)">{{ item.name }}</p>
            <p class="star-count">星级：{{ item.star }}</p>
            <p>{{ item.handNum }}</p>
          </div>
        </li>
        <div class="without-anything-wrap" v-show="withoutData">
          <img src="../../assets/icon/cl_without_anything.png" alt="" />
          <span>暂无粉丝</span>
        </div>
      </ul>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="totalPage"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        :page-size="12"
        ref="pagination"
        @current-change="curtListPageClick"
      >
        <!-- @prev-click="prevtListPageClick"  @next-click="nextListPageClick" -->
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../utils/apiMap";
import UserAvatar from "../../components/UserAvatar";
export default {
  name: "user-fans",
  data() {
    return {
      fansList: [],
      fansTotal: 0,
      listPage: 1,
      loadList: true,
      withoutData: false,
    };
  },
  components: {
    UserAvatar,
  },
  computed: {
    totalPage() {
      return this.fansTotal;
    },
  },
  created() {
    this.getFansList(1);
  },
  methods: {
    getFansList(page) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let fetchId = this.$route.query.id;
      var numberRegExp = /^[0-9]+$/;
      if (!numberRegExp.test(fetchId)) {
        return false;
      }
      let paramArr = [
        `token=${loginUser.token}`,
        `userId=${fetchId}`,
        `type=2`,
        `start=${page}`,
        `count=12`,
      ];
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["followList"]["method"],
          url: apiMap["followList"]["url"],
          data: paramArr.join("&"),
        })
        .then(function (response) {
          _this.loadList = false;
          if (response.data.result.statusCode == 1) {
            _this.fansList = response.data.result.data;
            // response.data.result.data.forEach(element => {
            //     _this.feedList.push(element);
            // });
            _this.fansTotal = response.data.result.count;
            // _this.$refs.pagination.internalCurrentPage = start;
          } else {
            _this.withoutData = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.listPage = newPage;
      this.getFansList(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.listPage = newPage;
      this.getFansList(newPage);
    },
    nextListPageClick(newPage) {
      this.listPage = newPage;
      this.getFansList(newPage);
    },
    userCenterLink(user) {
      if (user.hasOwnProperty("userId")) {
        this.$router.push({
          path: "/feed",
          query: {
            id: user.userId,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.list-wrap {
  min-height: 600px;
}

.list-container {
  display: flex;
  flex-wrap: wrap;
  /* min-height: 214px; */
}

.item-title {
  padding-left: 15px;
  font-size: 14px;
}

.list-item {
  /* float: left; */
  width: 415px;
  /* height: 90px; */
  padding: 15px;
  margin-top: 10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.list-item:nth-of-type(even) {
  margin-left: 10px;
}

.user-info-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
  line-height: 20px;
  font-size: 15px;
}

.user-avatar-wrap {
  cursor: pointer;
}

.star-count {
  padding-left: 22px;
  background-repeat: no-repeat;
  background-position: 1px 2px;
  background-image: url("../../assets/icon/user/cl_level_star.png");
}

.pagination-wrapper {
  margin: 10px 0;
  padding: 5px 0;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper:empty {
  padding: 0;
}

.without-anything-wrap {
  display: flex;
  width: 100%;
  padding: 60px 0;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  color: #808080;
  background-color: #fff;
}
</style>